import { render, staticRenderFns } from "./dataCockpit.vue?vue&type=template&id=42f21839&scoped=true"
import script from "./dataCockpit.vue?vue&type=script&lang=js"
export * from "./dataCockpit.vue?vue&type=script&lang=js"
import style0 from "./dataCockpit.vue?vue&type=style&index=0&id=42f21839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f21839",
  null
  
)

export default component.exports